
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["treemap-demo-common","treemap-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Treemap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.en.md?type=demo')
};